import { motion } from "framer-motion";

export const easeOutExpo = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", as = "div" }) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: easeOutExpo, delay }}
    >
      {children}
    </M>
  );
}

// Line-by-line masked reveal for hero headlines
export function MaskLines({ lines, className = "", delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="sh-line-mask">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, ease: easeOutExpo, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
